__turbopack_context__.v({
  "layoutPlug": "GalleryTemplate-module-scss-module__Z0QPFG__layoutPlug",
});
